import React, {memo} from 'react';
import {useCurrentUser} from "../../security";
import {getClientPlacementRootUrl, placementListUrl} from "../../placement/routes";
import {hasPlacementAccess} from "../domain/security";
import info from "../../actuator/info.json";
import {useLocation} from "react-router";

type AppTitleProps = {
    currentSelection: 'CLIENT PLACEMENT';
};

type Title = {
    name: string;
    url: string;
}

export const AppTitle = memo(({currentSelection}: AppTitleProps) => {
    const currentUser = useCurrentUser();
    const location = useLocation();
    const rootUrl = getClientPlacementRootUrl(location.pathname);
    const items: Array<Title> = [];
    if (hasPlacementAccess(currentUser)) {
        items.push({
            name: 'CLIENT PLACEMENT',
            url: placementListUrl(rootUrl)
        });
    }

    const feVersion = `v${info["version"]}-${info["commit"]}`;

    return (
        <>
            {items.map((item, idx) => {
                    const hasMore = items.length > idx + 1;
                    return (
                        <div key={idx} className="text-xl">
                            <a href={item.url}>
                        <span className={currentSelection === item.name ? "text-white" : "text-black"}>
                            {item.name}
                        </span>
                            </a>
                            {hasMore && <span> &nbsp; | &nbsp; </span>}
                        </div>
                    );
                }
            )}

            <div className="pl-2 cursor-not-allowed text-black">
                &nbsp;{feVersion}
            </div>
        </>
    );
});
